


import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import Button from "../../shared/Button"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { addSSSItem } from "../../../features/adminSett/adminSettSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1300px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 100%;
            padding: 30px;
            margin: 40px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .form-container{
                width: 80%;
                min-height: 300px;
                border: 1px solid ${({ theme }) => theme.mainBorderColor};
                padding: 30px;
                border-radius: 15px;

                .question-container{
                    width: 100%;
                    margin-bottom: 40px;

                    .textarea-question{
                        width: 100%;
                        padding: 10px;
                        color: ${({ theme }) => theme.mainTextColor};
                        border-bottom: 1px solid ${({ theme }) => theme.mainTextColor};
                        resize: vertical;
                        min-height: 40px;
                        background-color: transparent;
                    }
                }

                .answer-container{
                    width: 100%;

                    .textarea-answer{
                        width: 100%;
                        background-color: transparent;
                        padding: 10px;
                        resize: vertical;
                        min-height: 140px;
                    }
                }
            }
            

            .message-container{
                width: 80%;
                margin-top: 20px;
                
                p{
                    font-size: 16px;
                    font-weight: var(--font-weight-lg);
                }
            }

        }



        .btn-container{
            width: 100%;
            height: 80px;
            border-top: 1px solid ${({ theme }) => theme.mainBorderColor};
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 40px;
        }


    }

    textarea{
        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #555;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
    }
`


const AddSSSItemModal = () => {


    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [question, setQuestion] = useState("")
    const [answer, setAnswer] = useState("")

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        dispatch(addSSSItem({question, answer}))
        dispatch(showModal(null))
    }


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"SSS Ekle"}/>
        <div className="content">
            <div className="form-container">

                <div className="question-container">
                    <textarea type="text" className="textarea-question" value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="Soru Metnini Giriniz..."/>
                </div>

                <div className="answer-container">
                    <textarea  value={answer} className="textarea-answer" onChange={(e) => setAnswer(e.target.value)} placeholder="Cevap Metnini Giriniz..."></textarea>
                </div>
            </div>
            <div className="message-container">
                <p>Cevap Metninde vurgulamak istediğiniz kısmın başına ve sonuna *(yıldız karakteri) koyabilirsiniz. </p>
            </div>
        </div>
        
        <div className="btn-container">
            <Button color={"#F4F4F4"} background={"#0EAC00"} width="260px" radius={"10px"} text={"SSS Ekle"} handleClick={handleSubmit}/>
            <Button color={"#F4F4F4"} background={"#FF0000"} width="260px" radius={"10px"} text={"Geri Dön"} handleClick={()=> dispatch(showModal(null))}/>
        </div>
    </div>
</ModalContainer>
  )
}

export default AddSSSItemModal